var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex1"},[_c('CustomScenarioChart',{attrs:{"period":_vm.customChartPeriod,"category":"age"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }